import React, { FC, useEffect, useState, useCallback, useRef } from "react";
import { AxiosError } from "axios";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import useSpinnerLoader from "../../../../shared/components/spinner-loader";
import TableHeaderOrdering, {
  Header,
  OrderData,
} from "../../../../shared/components/table-header-ordering";
import { notificationService } from "../../../../shared/services/notification-service";
import TableRowNoData from "../../../../shared/components/molecules/commons/table-row-no-data";
import { HrOnlineService } from "../../../../shared/services/Report/HrOnline/hr-online";
import {
  Document,
  Page,
  View,
  Text,
  PDFDownloadLink,
  Font,
} from "@react-pdf/renderer";

import moment from "moment";
import PaginationForm from "../../../../shared/components/molecules/commons/pagination-form";
Font.register({
  family: "kanit-regular",
  src: "https://fonts.gstatic.com/s/kanit/v1/L6VKvM17ZmevDynOiw7H9w.ttf",
});
Font.register({
  family: "kanit-200",
  src: "https://fonts.gstatic.com/s/kanit/v1/wfLWkj1C4tYl7MoiFWS3bA.ttf",
});
const zw = "\u200B";
// Type definition for PDFDownloadLink render function
interface PDFDownloadLinkRenderProps {
  blob: Blob | null;
  url: string | null;
  loading: boolean;
  error: Error | null;
}

const thaiMonths = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

const ReportRetirementTrendNext3YearsOTKByManagerListPage: FC = () => {
  const [queryParams, setQueryParams] = useState<any>({
    ordering_field: "",
    ordering: "",
    page: 1,
    page_size: 10,
    year: moment().year() + 543,
  });
  const [data, setData] = useState<any>([]);
  const [dataExport, setDataExport] = useState<any>([]);
  const { loaderComponent, startLoading, stopLoading } = useSpinnerLoader();
  const loadingRef = useRef({ startLoading, stopLoading });
  loadingRef.current = { startLoading, stopLoading };

  const headers: Header[] = [
    {
      label: "ลำดับ",
      field: "index",
      order: null,
      isOrder: true,
    },
    {
      label: "ผู้บริหาร",
      field: "type",
      order: null,
      isOrder: true,
    },
    {
      label: "กรอบ",
      field: "total_power_rate",
      order: null,
      isOrder: true,
    },
    {
      label: "บรรจุจริง",
      field: "actual_filled",
      order: null,
      isOrder: true,
    },
    {
      label: (moment().year() + 543).toString(),
      field: "retire_current",
      order: null,
      isOrder: true,
    },
    {
      label: String(moment().year() + 544),
      field: "retire_next1",
      order: null,
      isOrder: true,
    },
    {
      label: String(moment().year() + 545),
      field: "retire_next2",
      order: null,
      isOrder: true,
    },
  ];

  const fetchData = useCallback(
    async (params: any) => {
      loadingRef.current.startLoading();
      try {
        const result =
          await HrOnlineService.getReportRetirementTrendNext3YearsOTKByManagerList(
            params
          );
        setData(result);
        setDataExport(result);
      } catch (error) {
        const err = error as AxiosError;
        notificationService.dangerNotification(
          "โหลดข้อมูลไม่สำเร็จ",
          err.message
        );
      } finally {
        loadingRef.current.stopLoading();
      }
    },
    [queryParams.ordering_field, queryParams.ordering]
  );

  const tableRowNoData = () => {
    if (data.rows?.employee?.length === 0) {
      return <TableRowNoData colspan={7} />;
    }
    return null;
  };

  const PDF: React.FC<{ data: any }> = ({ data }) => (
    <Document>
      <Page size="A4" style={{ padding: 20, fontFamily: "kanit-regular" }}>
        <View>
          {/* หัวรายงาน */}
          <View style={{ marginBottom: 20 }}>
            <Text
              style={{
                fontSize: 16,
                textAlign: "center",
                marginBottom: 1,
                fontFamily: "kanit-regular",
              }}
            >
              {"องค์การตลาดเพื่อเกษตรกร"+ zw}
            </Text>

            <Text
              style={{
                fontSize: 16,
                textAlign: "center",
                marginBottom: 1,
                fontFamily: "kanit-regular",
              }}
            >
              {"รายงานการเกษียณของตำแหน่งเป้าหมายในอีก 3 ปี ข้างหน้า"+ zw}  
            </Text>

            <Text
              style={{
                fontSize: 16,
                textAlign: "center",
                marginBottom: 1,
                fontFamily: "kanit-regular",
              }}
            >
              ประจำวันที่{" "}
              {moment().format("D") +
                " " +
                thaiMonths[moment().month()] +
                " " +
                (moment().year() + 543) +
                zw}
            </Text>
          </View>

          {/* ตาราง - ครอบทั้งตารางด้วย View เดียว */}
          <View
            style={{
              border: "1px solid black",
            }}
          >
            {/* หัวตาราง */}
            <View
              style={{
                flexDirection: "row",
                borderBottom: "1px solid black",
                fontFamily: "kanit-regular",
                fontSize: 11,
              }}
              fixed
            >
              <Text
                style={{
                  width: "8%",
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {"ลำดับ"+ zw}
              </Text>
              <Text
                style={{
                  width: "22%",
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {"ผู้บริหาร"+ zw}
              </Text>
              <Text
                style={{
                  width: "12%",
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {"กรอบ"+ zw}
              </Text>
              <Text
                style={{
                  width: "12%",
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {"บรรจุจริง"+ zw}
              </Text>
              <Text
                style={{
                  width: "14%",
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {moment().year() + 543 + zw}
              </Text>
              <Text
                style={{
                  width: "14%",
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {moment().year() + 544 + zw}
              </Text>
              <Text
                style={{
                  width: "18%",
                  textAlign: "center",
                  padding: 5,
                }}
              >
                {moment().year() + 545 + zw}
              </Text>
            </View>

            {/* ข้อมูลผู้บริหาร */}
            {data.rows?.manager?.map((item: any, index: any) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  fontFamily: "kanit-200",
                  fontSize: 10,
                  borderBottom: "1px solid black",
                }}
              >
                <Text
                  style={{
                    width: "8%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {index + 1}
                </Text>
                <Text
                  style={{
                    width: "22%",
                    textAlign: "left",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {"ผู้บริหาร "+ item.level + zw}
                </Text>
                <Text
                  style={{
                    width: "12%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.total_power_rate + zw}
                </Text>
                <Text
                  style={{
                    width: "12%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.actual_filled + zw}
                </Text>
                <Text
                  style={{
                    width: "14%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.retire_current + zw}
                </Text>
                <Text
                  style={{
                    textAlign: "center",
                    width: "14%",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.retire_next1 + zw}
                </Text>
                <Text
                  style={{
                    width: "18%",
                    textAlign: "center",
                    padding: 5,
                  }}
                >
                  {item.retire_next2 + zw}
                </Text>
              </View>
            ))}

            {/* รวม */}
            {data.rows?.total_all?.map((item: any, index: any) => (
              <View
                key={index}
                style={{
                  fontFamily: "kanit-regular",
                  fontSize: 10,
                  flexDirection: "row",
                }}
              >
                <Text
                  style={{
                    width: "8%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                ></Text>
                <Text
                  style={{
                    width: "22%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {"รวม"+ zw}
                </Text>
                <Text
                  style={{
                    width: "12%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.total_power_rate + zw}
                </Text>
                <Text
                  style={{
                    width: "12%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.actual_filled + zw}
                </Text>
                <Text
                  style={{
                    width: "14%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.retire_current + zw }
                </Text>
                <Text
                  style={{
                    width: "14%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.retire_next1 + zw}
                </Text>
                <Text
                  style={{
                    width: "18%",
                    textAlign: "center",
                    padding: 5,
                  }}
                >
                  {item.retire_next2 + zw }
                </Text>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  );
  useEffect(() => {
    fetchData(queryParams);
  }, [fetchData, queryParams]);

  return (
    <>
      <div className="d-flex justify-content-between py-4">
        <h2 className="text-mof-primary m-0">
          รายงานการเกษียณของตำแหน่งเป้าหมายในอีก 3 ปี ข้างหน้า
        </h2>
      </div>
      {loaderComponent}
      <div className="row">
        {/* <label className="form-label">ปี</label>
        <div className="col-sm-12 col-md-2">
          <input
            className="form-control"
            type="text"
            value={queryParams.year ? queryParams.year : ""}
            onChange={handleYearChange}
            name="search"
          />
        </div>
        <div className="col-sm-12 col-md-4">
          <Button
            variant="primary"
            type="button"
            className="d-inline-block px-4"
            onClick={() => fetchData(queryParams)}
          >
            <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
          </Button>
        </div> */}
        <div className="col-sm-12 col-md-12 d-flex justify-content-end">
          <PDFDownloadLink
            document={<PDF data={dataExport} />}
            fileName={`รายงานการเกษียณของตำแหน่งเป้าหมายในอีก 3 ปี ข้างหน้า${queryParams.year}.pdf`}
          >
            {
              (({ loading }: any) => (
                <Button
                  variant="primary"
                  className="btn-action btn-mof-primary me-2"
                  disabled={loading}
                >
                  <FontAwesomeIcon icon={faFileExport} className="me-2" />
                  {loading ? "Loading..." : "Export"}
                </Button>
              )) as any
            }
          </PDFDownloadLink>
        </div>
      </div>

      <div className="overflow-auto mt-3">
        <Table striped bordered hover>
          <thead>
            <TableHeaderOrdering
              headers={headers}
              onChangeOrder={(orderData: OrderData) => {
                setQueryParams({
                  ...queryParams,
                  ordering_field: orderData.field,
                  ordering: orderData.order,
                });
              }}
              isShow={true}
            />
          </thead>
          <tbody>
            {data.rows?.manager?.map((data: any, index: any) => {
              return (
                <ReportRetirementTrendNext3YearsBYManagerRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type={`ผู้บริหาร ${data.level}`}
                />
              );
            })}

            {data.rows?.total_all?.map((data: any, index: any) => {
              return (
                <ReportRetirementTrendNext3YearsBYManagerRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="รวม"
                  bold={true}
                />
              );
            })}
            {tableRowNoData()}
          </tbody>
        </Table>
      </div>
    </>
  );
};

const ReportRetirementTrendNext3YearsBYManagerRow: FC<any> = ({
  index,
  total_power_rate,
  actual_filled,
  retire_current,
  retire_next1,
  retire_next2,
  type = null,
  bold = false,
}) => {
  return (
    <tr style={{ fontWeight: bold ? "bold" : "normal" }}>
      <td>{type === "รวม" ? "" : index}</td>
      <td>{type}</td>
      <td>{total_power_rate}</td>
      <td>{actual_filled}</td>
      <td>{retire_current}</td>
      <td>{retire_next1}</td>
      <td>{retire_next2}</td>
    </tr>
  );
};

export default ReportRetirementTrendNext3YearsOTKByManagerListPage;
